<template>
  <div>
    <editor
      @input="$emit('input', $event)"
      ref="editor"
      :init="simple ? simpleEditorInit : editorInit"
      :value="value"
    >
    </editor>
    <images-dialog
      :bus="bus"
      @cancel="dialogCancelled"
      @submit="dialogSubmitted"
    />
    <el-dialog
      title="Wgraj plik"
      class="file-dialog"
      width="408px"
      top="0"
      center
      append-to-body
      :visible.sync="innerVisible"
    >
      <el-upload
        class="upload-demo"
        drag
        action=""
        :show-file-list="false"
        :http-request="sendFile"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Przeciągnij i upuść plik lub <em>kliknij tutaj</em>
        </div>
      </el-upload>
      <br />
      <span slot="footer" class="dialog-footer">
        <el-button @click="innerVisible = false">Cancel</el-button>
        <el-button type="primary" @click="innerVisible = false"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import tinymce from 'tinymce/tinymce'
import 'tinymce/themes/modern/theme'
import 'tinymce/skins/lightgray/content.min.css'
import 'tinymce/skins/lightgray/skin.min.css'
import ImagesDialog from '@/components/inputs/ImageDialog/'
import Vue from 'vue'
import { Attachment } from '@/api'

// plugins
import 'tinymce/plugins/advlist'
import 'tinymce/plugins/image'
import 'tinymce/plugins/autoresize'
import 'tinymce/plugins/textcolor'
import 'tinymce/plugins/colorpicker'
import 'tinymce/plugins/imagetools'
import 'tinymce/plugins/link'
import 'tinymce/plugins/media'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/code'

export default {
  props: {
    value: { type: String },
    simple: { type: Boolean }
  },
  data() {
    return {
      bus: new Vue(),
      activeInput: null,
      innerVisible: false,
      simpleEditorInit: {
        menubar: false,
        plugins:
          'advlist image autoresize imagetools textcolor colorpicker paste media link code',
        toolbar: 'bold italic backcolor forecolor | link code',
        file_browser_callback: (field_name, url, type, win) => {
          this.activeInput = win.document.getElementById(field_name)
          this.openDialog()
        }
      },
      editorInit: {
        menubar: false,
        image_advtab: true,
        extended_valid_elements:
          'svg[*],defs[*],pattern[*],desc[*],metadata[*],g[*],mask[*],path[*],line[*],marker[*],rect[*],circle[*],ellipse[*],polygon[*],polyline[*],linearGradient[*],radialGradient[*],stop[*],image[*],view[*],text[*],textPath[*],title[*],tspan[*],glyph[*],symbol[*],switch[*],use[*]',
        plugins:
          'advlist image autoresize imagetools textcolor colorpicker paste media link lists code',
        toolbar:
          'undo redo | formatselect | bold italic underline | bullist numlist | removeformat | media link code',
        block_formats: 'Paragraph=p;Header 2=h2;Header 3=h3;Header 4=h4',
        content_css: '/static/wyswig.css',
        advlist_bullet_styles: 'default',
        paste_data_images: true,
        setup: editor => {
          // editor.addButton('blackButton', {
          //     text: 'Czarny przycisk',
          //     icon: false,
          //     onclick: () => {
          //         this.addBlackButton(editor)
          //     }
          // });
        },
        file_browser_callback: (field_name, url, type, win) => {
          this.activeInput = win.document.getElementById(field_name)
          this.openDialog()
        }
      }
    }
  },
  watch: {
    value(value) {
      if (value === undefined) {
        this.$emit('input', '')
      }
    }
  },
  components: {
    ImagesDialog
  },
  methods: {
    sendFile(option) {
      const data = new FormData()
      data.append('file', option.file, option.file.name)
      return Attachment.upload(data)
        .then(response => {
          this.uploadSuccess(response)
        })
        .catch(error => {
          this.uploadError(error)
        })
    },
    uploadSuccess(response) {
      this.activeInput.value = response.data.file
      this.closeDialog()
    },
    uploadError(error) {
      console.error(error, 'error while file uploading')
      this.$message({
        message: 'Wystąpił problem podczas wysyłania pliku.',
        type: 'error'
      })
    },
    openDialog() {
      this.innerVisible = true
    },
    closeDialog() {
      this.innerVisible = false
    },
    // addBlackButton (editor) {
    //     const button = this.getBlackButtonHTML('Nazwa przycisku')
    //     editor.insertContent(button);
    // },
    // getBlackButtonHTML (title) {
    //     return `
    //       <button class="btn btn--black btn--inline-block">${title}</button>
    //     `
    // },
    openImagesDialog() {
      this.bus.$emit('openImagesDialog')
    },
    dialogCancelled() {
      // cancel
    },
    dialogSubmitted(image) {
      this.activeInput.value = image
      this.closeDialog()
    }
  }
}
</script>
<style lang="scss" scoped>
.el-dialog {
}

.el-dialog__body {
  text-align: center !important;
}

.file-dialog {
  margin-top: 0 !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  z-index: 775664 !important;
  text-align: center;
}

.btn {
  display: block;
  margin: 0 auto;

  width: 160px;
  height: 38px;
  padding: 11px 0;
  border: 1px solid #000;

  font-size: 12px;
  font-weight: 700;
  text-align: center;
  color: #000;
  cursor: pointer;
  text-transform: uppercase;
  text-decoration: none;

  transition: 0.1s ease-in-out;

  &:hover,
  &:focus {
    background: #000;
    color: #fff;
  }

  &--submit {
    width: 140px;
    border: none;
    background: #fff;
    text-transform: lowercase;
  }

  &--black {
    width: 120px;
    height: 40px;
    background: #000;
    color: #fff;
    text-transform: uppercase;

    &:hover,
    &:focus {
      border: 1px solid black;
      background: #fff;
      color: #000;
    }
  }
}

.existing-button {
  text-align: center;
}
</style>
